import { EventBus } from 'core-components/classes/events/Bus'

export const eltEventBus = new EventBus(
  ['updatePartnerGroupMembers', 'changeGroupMainHqPartner', 'updateScoreCardData'],
  'eltEventBus'
)
